import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CreateCashPaymentRequest, CreateCashPaymentResponse } from '../../interface/CustomerRecharge';
import { ApiResponse } from '../../api/api';
import customerRechargeService from '../../services/customerRechargeService';
import { CUSTOMER_RECHARGE_ACTIONS } from '../../constant/stringConstant';

export const createCashPayment = createAsyncThunk<
  ApiResponse<CreateCashPaymentResponse>,
  CreateCashPaymentRequest,
  { rejectValue: string }
>(
 CUSTOMER_RECHARGE_ACTIONS.CREATE_CASH_PAYMENT,
  async (request, { rejectWithValue }) => {
    try {
      return await customerRechargeService.createCashPayment(request);
    } catch (error) {
      return rejectWithValue(error as any);
    }
  }
);

export interface CreateCashPaymentState {
  cashPayment: ApiResponse<CreateCashPaymentResponse> | null;
  loading: boolean;
  error: string | null;
}

const initialState: CreateCashPaymentState = {
  cashPayment: null,
  loading: false,
  error: null,
};

const createCashPaymentSlice = createSlice({
  name: 'createCashPayment',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createCashPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCashPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.cashPayment = action.payload;
      })
      .addCase(createCashPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || null;
      });
  },
});

export default createCashPaymentSlice.reducer;
